import React from 'react';
import { SECTION_NAMES } from './IntegrationRequestOrResponseLogModal';
import { dateCreatedFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import ReqResTextarea from 'components/integrations/ReqResTextarea';

const IntegrationReqOrResTable = ({ row, sectionName, isBeautify }) => {
    const COLUMN_NAMES = ["created_at", "req_method", "req_headers", "posting_url", "campaign_name", "is_test"];
    const OBJECTS_COLUMN_NAMES = ["req_body", "res_body", "req_headers", "req_params"];
    const entries = row ? Object.entries(row).filter(([key, value]) => {
        if (sectionName === SECTION_NAMES.REQUEST && key === "req_body" || sectionName === SECTION_NAMES.REQUEST && key === "req_params") {
            return true;
        }
        if (sectionName === SECTION_NAMES.RESPONSE) {
            return key === "res_body" || key === "created_at"
        }
        return COLUMN_NAMES.includes(key);
    }) : [];

    //Moving created_at feild near to req_method
    const reqMethodIndex = entries.findIndex(([key]) => key === 'req_method');
    const createdAtEntry = entries.find(([key]) => key === 'created_at');
    const requestEntries = entries.filter(([key]) => key !== 'created_at');
    if (reqMethodIndex !== -1 && createdAtEntry) {
        requestEntries.splice(reqMethodIndex + 1, 0, createdAtEntry);
    }

    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">key</th>
                        <th scope="col">Value</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (sectionName === SECTION_NAMES.REQUEST ? requestEntries : entries).map(([key, value]) => {
                            const timeStampFeildForRequest = key === "created_at" && sectionName === SECTION_NAMES.REQUEST
                            const timeStampFeildForResponse = key === "created_at" && sectionName === SECTION_NAMES.RESPONSE
                            const timeStampField = key === "created_at";
                            return (
                                <tr style={{cursor: 'default'}}>
                                    <td className="text-capitalize">{timeStampFeildForRequest ? "Sent at" : (timeStampFeildForResponse ? "Received at" : key.replaceAll("_", " "))}</td>
                                    <td>
                                        {
                                            OBJECTS_COLUMN_NAMES.includes(key) ? (value &&
                                                <ReqResTextarea isBeautify={isBeautify} key={key} val={value}/>
                                            ) : key === "is_test" ? (
                                                value ? "Yes" : "No"
                                            ) : (
                                                timeStampField ? dateCreatedFormatter(value) : value
                                            )
                                        }
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </>
    )
}

export default IntegrationReqOrResTable
